<template>
  <div class="homeContainer">
    <homeHeader @topNavEvent="topNav"></homeHeader>
    <keep-alive>
      <monthList v-if="navNum == 0"></monthList>
      <quarterList v-if="navNum == 1"></quarterList>
    </keep-alive>

    <footCom></footCom>
    <div class="slideRight">
      <p class="pBox">2018中国人身保险产品研究报告（消费者版）</p>
      <img src="http://www.cfbond.com/static/images/wxgzh.jpg" />
      <p>
        关注官方微信
        <br />>发送“人身保险”即可下载
      </p>
    </div>
  </div>
</template>

<script>
import homeHeader from "../../components/header/homeHeader";
import monthList from "../../components/itemList/monthList";
import quarterList from "../../components/itemList/quarterlyList";
import footCom from "../../components/footer/footer";
export default {
  components: { homeHeader, monthList, footCom, quarterList },
  data() {
    return {
      navNum: 0
    };
  },
  methods: {
    topNav(data) {
      this.navNum = data;
    }
  }
};
</script>

<style scoped>
.homeContainer {
  position: relative;
}
.slideRight {
  width: 155px;
  height: 260px;
  border: 1px solid #ff8109;
  border-radius: 5px;
  background: #fffbf6;
  text-align: center;
  padding: 10px;
  position: fixed;
  right: 20px;
  bottom: 300px;
  text-align: center;
}

.slideRight p {
  line-height: 24px;
  margin-bottom: 15px;
  font-size: 12px;
}

.slideRight .pBox {
  font-size: 16px;
  padding: 0 11px;
}

.slideRight img {
  width: 126px;
}

.slideRight span {
  display: inline-block;
  width: 109px;
  line-height: 30px;
  height: 30px;
  background: #ff8109;
  color: #fff;
  outline: none;
  border: none;
  border-radius: 5px;
  font-weight: bold;
}
@media screen and (min-width: 768px) and (max-width: 1366px) {
  .slideRight {
    width: 155px;
    height: 260px;
    border: 1px solid #ff8109;
    border-radius: 5px;
    background: #fffbf6;
    text-align: center;
    padding: 10px;
    position: absolute;
    right: 50px;
    bottom: 50px;
  }
}
@media screen and (min-width: 100px) and (max-width: 768px) {
  .slideRight {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/home/home.vue